import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';
import PasswordReset from './PasswordReset';
import UserDashboard from './UserDashboard';
import UploadFilm from './UploadFilm';
import ChangePassword from './ChangePassword';
import FilmDetails from './FilmDetails';
import { Navigate } from 'react-router-dom';
import PublicFilms from './PublicFilms';
import SubmitReview from './SubmitReview';
import UserReviews from './UserReviews';
import EditReview from './EditReview';
import BuyTokens from './BuyTokens'; 
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import EditFeedbackCategories from './EditFeedbackCategories';
import TransactionHistory from './TransactionHistory';
import Notifications from './Notifications';
import AdminPage from './AdminPage';
import VerifyEmail from './VerifyEmail';
import About from './About';
import './index.css';
import jwtDecode from 'jwt-decode';
import { useCallback } from 'react';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_12345');

function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token); // Decode the token to get the expiration time
    return Date.now() >= exp * 1000; // Compare current time with expiration time
  } catch (err) {
    return true; // If decoding fails, treat the token as expired
  }
}

function checkAuthStatus() {
  const token = localStorage.getItem('token');
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('token'); // Clear the token
    localStorage.removeItem('user_id'); // Clear user ID
    return false; // User is not authenticated
  }
  return true; // User is authenticated
}

function PrivateRoute({ isLoggedIn, children }) {
  return isLoggedIn ? children : <Navigate to="/login" />;
}


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token')); // Check if token exists
  const [error, setError] = useState('');
 /* const navigateToLogin = useCallback(() => {
    navigate('/login');
    }, [navigate]);
    
    useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token || isTokenExpired(token)) {
        alert('Your session has expired. Please sign back in.');
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        setIsLoggedIn(false);
        navigateToLogin(); // Use the stable callback
      }
    }, [navigateToLogin]);
    */

  return (
    <Elements stripe={stripePromise}>

    <Router>
      <div>
        <Navigation isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        <Routes>
          <Route
            path="/"
            element={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: '100vh',
                  width: '100vw',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                {/* Responsive Background Image */}
                <img
                  src="/images/home-image.jpg"
                  alt="Home Background"
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    minHeight: '100vh',
                    objectFit: 'cover',
                    opacity: 0.4,
                    zIndex: -2,
                  }}
                />
                {/* Radial Gradient Overlay */}
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    minHeight: '100vh',
                    background: 'radial-gradient(circle, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.6) 100%)',
                    zIndex: -1,
                  }}
                ></div>
                {/* Centered Welcome Message */}
                <div
                  style={{
                    position: 'relative',
                    margin: 'auto',
                    textAlign: 'center',
                    color: '#000',
                    fontFamily: "'Poppins', sans-serif",
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                    padding: '5vw 2vw',
                    width: '100%',
                  }}
                >
                  <h1
                    style={{
                      fontSize: 'clamp(2.5rem, 8vw, 7rem)',
                      fontWeight: 'bold',
                      marginBottom: '20px',
                      lineHeight: 1.1,
                    }}
                  >
                    Welcome to <br /> Eat Our Shorts!
                  </h1>
                  <p
                    style={{
                      fontSize: 'clamp(1.2rem, 4vw, 3rem)',
                      fontWeight: 'bold',
                      marginTop: '10px',
                      lineHeight: 1.2,
                    }}
                  >
                    A communal platform for <br /> giving and getting feedback <br /> on your films!
                  </p>
                </div>
              </div>
            }
          />
          <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} error={error} setError={setError} />} />          <Route path="/register" element={<Register />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <UserDashboard />
              </PrivateRoute>
            }
          />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/upload-film" element={<UploadFilm />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/films/:film_id" element={<FilmDetails />} />
          <Route path="/public-films" element={<PublicFilms />} />
          <Route path="/films/:film_id/review" element={<SubmitReview />} />
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
          <Route path="/my-reviews" element={<UserReviews />} />
          <Route path="/reviews/:review_id/edit" element={<EditReview />} />
          <Route path="/buy-tokens" element={<BuyTokens />} />
          <Route path="/films/:film_id/edit-feedback-categories" element={<EditFeedbackCategories />} />
          <Route path="/transaction-history" element={<TransactionHistory />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/about" element={<About />} />          


        </Routes>

        <footer
        style={{
          textAlign: 'center',
          padding: '10px 20px',
          background: 'linear-gradient(90deg, #6a5acd, #20b2aa)', // Gradient background
          color: '#ffffff', // White text color
          fontFamily: 'Arial, sans-serif',
          boxShadow: '0 -4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
        }}
      >
        <p style={{ margin: 0, fontSize: '14px' }}>
          &copy; 2025 EatOurShorts Platform. All rights reserved.
        </p>
      </footer>
      </div>
    </Router>
    </Elements>

  );
}



function Navigation({ isLoggedIn, setIsLoggedIn }) {
  const navigate = useNavigate(); // Declare navigate here for use in the navigation bar

  return (
    <nav
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 20px',
        background: 'linear-gradient(90deg, #6a5acd, #20b2aa)', // Gradient background
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {!isLoggedIn ? (
        <>
          <NavLink
            to="/"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0', // White for active, light gray for inactive
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0', // White for active, light gray for inactive
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            About
          </NavLink>
          <NavLink
            to="/login"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0',
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            Login / Register
          </NavLink>
 
            <NavLink
            to="/public-films"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0', // White for active, light gray for inactive
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            Public Films
          </NavLink>
        </>
      ) : (
        <>
          <NavLink
            to="/dashboard"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0',
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/public-films"
            style={({ isActive }) => ({
              color: isActive ? '#ffffff' : '#f0f0f0', // White for active, light gray for inactive
              textDecoration: 'none',
              margin: '0 15px',
              fontSize: '16px',
              fontWeight: isActive ? 'bold' : 'normal',
              transition: 'color 0.3s',
            })}
          >
            Public Films
          </NavLink>
          <button
            onClick={() => {
              localStorage.removeItem('token');
              localStorage.removeItem('user_id');
              setIsLoggedIn(false); // Update state to reflect logout
              alert("You've logged out. That's a wrap! 🎬 See you at the next screening!"); // Funny farewell message
              navigate('/'); // Redirect to the Home Page
            }}
            style={{
              color: '#ff4500', // Bright red for logout button
              textDecoration: 'none',
              margin: '0 15px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              transition: 'color 0.3s',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#ff6347')} // Slightly lighter red on hover
            onMouseLeave={(e) => (e.target.style.color = '#ff4500')}
          >
            Logout
          </button>
        </>
      )}
    </nav>
  );
}

function Login({ setIsLoggedIn, error, setError }) {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const navigate = useNavigate(); // Declare navigate here for use in the login function

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      console.log('Attempting login...');
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/login`, { usernameOrEmail, password });
      console.log('Login successful:', response.data);
      setError('');
      localStorage.setItem('token', response.data.token); // Store the token in localStorage
      localStorage.setItem('user_id', response.data.user.id); // Correctly access the user ID      console.log('Token and user_id stored in localStorage');
      setIsLoggedIn(true); // Update state to reflect login
      console.log('isLoggedIn state updated:', true);
      navigate('/dashboard'); // Redirect to the Dashboard
      console.log('Navigating to Dashboard...');
    } catch (err) {
      console.error('Login failed:', err); // Log the error
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh', // Full viewport height
    backgroundColor: '#f0f8ff', // Light blue background
    fontFamily: "'Poppins', sans-serif", // Modern font
  }}
>
  <div
    style={{
      backgroundColor: '#ffffff', // White card background
      padding: '40px',
      borderRadius: '20px', // Softer rounded corners
      boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)', // Stronger shadow for depth
      width: '100%',
      maxWidth: '450px', // Slightly smaller max width for compact design
      textAlign: 'center',
    }}
  >
    <p
  style={{
    marginTop: '20px',
    fontSize: '18px',
    color: '#555',
  }}
>
  Don't have an account?{' '}
  <NavLink
    to="/register"
    style={{
      color: '#6a5acd', // Soft purple link
      textDecoration: 'none',
      fontWeight: 'bold',
    }}
  >
    Register here
  </NavLink>
</p>

    <h1
      style={{
        color: '#6a5acd', // Soft purple color
        marginBottom: '20px',
        fontSize: '2rem', // Larger font size
        fontWeight: 'bold',
        textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)', // Subtle shadow for text
      }}
    >
      Welcome Back!
    </h1>
    <p
      style={{
        color: '#555', // Subtle gray for secondary text
        marginBottom: '30px',
        fontSize: '1rem',
      }}
    >
      Please login to your account.
    </p>
<form
  onSubmit={handleLogin}
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px', // Increased gap for better spacing
    width: '100%',
  }}
>
  <input
    type="text"
    placeholder="Username or Email"
    value={usernameOrEmail}
    onChange={(e) => setUsernameOrEmail(e.target.value)}
    required
    style={{
      width: '94%',
      padding: '15px',
      border: '1px solid #dcdcdc',
      borderRadius: '10px',
      fontSize: '16px',
      boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
      transition: 'border-color 0.3s',
    }}
    onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
    onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
  />
  <div style={{ position: 'relative', width: '94%' }}>
    <input
      type={showPassword ? 'text' : 'password'} // Toggle between 'text' and 'password'
      placeholder="Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
      style={{
        width: '100%',
        padding: '15px',
        border: '1px solid #dcdcdc',
        borderRadius: '10px',
        fontSize: '16px',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'border-color 0.3s',
      }}
      onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
      onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
    />
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
      style={{
        position: 'absolute',
        right: '-20px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        color: '#6a5acd',
      }}
    >
      {showPassword ? 'Hide' : 'Show'}
    </button>
  </div>
  <button
    type="submit"
    style={{
      width: '100%',
      padding: '15px',
      backgroundColor: '#20b2aa',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: 'bold',
      transition: 'background-color 0.3s, transform 0.2s',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#1e9e94';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = '#20b2aa';
      e.target.style.transform = 'scale(1)';
    }}
  >
    Login
  </button>
</form>
    {error && (
      <p
        style={{
          color: '#ff4500', // Bright red for error messages
          fontWeight: 'bold',
          marginTop: '15px',
        }}
      >
        {error}
      </p>
    )}
    <p
      style={{
        marginTop: '20px',
        fontSize: '14px',
        color: '#555',
      }}
    >
      Forgot your password?{' '}
      <NavLink
        to="/password-reset"
        style={{
          color: '#6a5acd', // Soft purple link
          textDecoration: 'none',
          fontWeight: 'bold',
        }}
      >
        Reset it here
      </NavLink>
    </p>
    <button
      onClick={() => navigate('/')}
      style={{
        marginTop: '20px',
        padding: '12px 20px',
        backgroundColor: '#9370db', // Medium purple button
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.3s',
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = '#7a5fc0')}
      onMouseLeave={(e) => (e.target.style.backgroundColor = '#9370db')}
    >
      Back to Home
    </button>
  </div>
</div>
  );
}

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [referralUsername, setReferralUsername] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility



  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/register`, {
        username,
        email,
        password,
        referral_username: referralUsername || null,

      });
      console.log('Registration successful:', response.data);
      setError('');
      alert('Registration successful! Please check your email for a welcome message.');
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh', // Full viewport height
    backgroundColor: '#f5f5ff', // Soft lavender background
    fontFamily: "'Poppins', sans-serif", // Modern font
  }}
>
  <div
    style={{
      backgroundColor: '#ffffff', // White card background
      padding: '40px',
      borderRadius: '20px', // Rounded corners
      boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)', // Subtle shadow for depth
      width: '94%',
      maxWidth: '450px', // Compact design
      textAlign: 'center',
    }}
  >
    <h1
      style={{
        color: '#6a5acd', // Soft purple color
        marginBottom: '20px',
        fontSize: '2rem', // Larger font size
        fontWeight: 'bold',
        textShadow: '1px 1px 3px rgba(0, 0, 0, 0.2)', // Subtle shadow for text
      }}
    >
      Register
    </h1>
<form
  onSubmit={handleRegister}
  style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto',
  }}
>
  <input
    type="text"
    placeholder="Username"
    value={username}
    onChange={(e) => setUsername(e.target.value)}
    required
    style={{
      width: '100%',
      padding: '15px',
      border: '1px solid #dcdcdc',
      borderRadius: '10px',
      fontSize: '16px',
      boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
      transition: 'border-color 0.3s',
    }}
    onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
    onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
  />
  <input
    type="email"
    placeholder="Email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
    style={{
      width: '100%',
      padding: '15px',
      border: '1px solid #dcdcdc',
      borderRadius: '10px',
      fontSize: '16px',
      boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
      transition: 'border-color 0.3s',
    }}
    onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
    onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
  />
  <div style={{ position: 'relative', width: '100%' }}>
    <input
      type={showPassword ? 'text' : 'password'}
      placeholder="Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
      style={{
        width: '100%',
        padding: '15px',
        border: '1px solid #dcdcdc',
        borderRadius: '10px',
        fontSize: '16px',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'border-color 0.3s',
      }}
      onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
      onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
    />
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: 'absolute',
        right: '-20px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        color: '#6a5acd',
      }}
    >
      {showPassword ? 'Hide' : 'Show'}
    </button>
  </div>
  <div style={{ position: 'relative', width: '100%' }}>
    <input
      type={showPassword ? 'text' : 'password'}
      placeholder="Confirm Password"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      required
      style={{
        width: '100%',
        padding: '15px',
        border: '1px solid #dcdcdc',
        borderRadius: '10px',
        fontSize: '16px',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'border-color 0.3s',
      }}
      onFocus={(e) => (e.target.style.borderColor = '#6a5acd')}
      onBlur={(e) => (e.target.style.borderColor = '#dcdcdc')}
    />
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: 'absolute',
        right: '-20px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        color: '#6a5acd',
      }}
    >
      {showPassword ? 'Hide' : 'Show'}
    </button>
  </div>
    <input
          type="text"
          placeholder="Referral Username (Optional)"
          value={referralUsername}
          onChange={(e) => setReferralUsername(e.target.value)}
          style={{
            width: '100%',
            padding: '15px',
            border: '1px solid #dcdcdc',
            borderRadius: '10px',
            fontSize: '16px',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'border-color 0.3s',
          }}
        />
  <button
    type="submit"
    style={{
      width: '100%',
      padding: '15px',
      backgroundColor: '#20b2aa',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: 'bold',
      transition: 'background-color 0.3s, transform 0.2s',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#1e9e94';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = '#20b2aa';
      e.target.style.transform = 'scale(1)';
    }}
  >
    Register
  </button>
</form>
    {error && (
      <p
        style={{
          color: '#ff4500', // Bright red for error messages
          fontWeight: 'bold',
          marginTop: '15px',
        }}
      >
        {error}
      </p>
    )}
    <button
      onClick={() => navigate('/')}
      style={{
        marginTop: '20px',
        padding: '12px 20px',
        backgroundColor: '#9370db', // Medium purple button
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.3s',
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = '#7a5fc0')}
      onMouseLeave={(e) => (e.target.style.backgroundColor = '#9370db')}
    >
      Back to Home
    </button>
  </div>
</div>
  );
}

export default App;